import type { IAdProvider, ITargetingManager } from '../types/ad-manager.interfaces';
import { AdTargetingKey } from '../types/google-tag.types';

export class TargetingManager implements ITargetingManager {
	constructor(private readonly provider: IAdProvider) {}

	applyDisciplineTargeting(discipline: string | undefined): boolean {
		const current = this.getCurrentDiscipline();

		// Nothing to do: no discipline selected and none set
		if (!discipline && !current) return false;

		// Already targeting the same discipline
		if (discipline && current === discipline) return false;

		// Clear previous targeting if any
		if (current) {
			this.provider.clearTargeting(AdTargetingKey.DISCIPLINE);
		}

		// Set new targeting if provided
		if (discipline) {
			this.provider.setTargeting(AdTargetingKey.DISCIPLINE, discipline);
		}

		return true;
	}

	private getCurrentDiscipline(): string | undefined {
		const values = this.provider.getTargeting(AdTargetingKey.DISCIPLINE);
		return values.length > 0 ? values[0] : undefined;
	}
}
